import { z } from 'zod';
import { SLUG_PATTERN } from './patterns.js';

/**
 * Connecting a server to the panel (TZ section 10.5, enrollment flow).
 *
 * The server itself comes from the 2d2s inventory (ADR-0002); what the operator
 * decides here is only how the panel treats it: its name, what it is for, and
 * how much of it the scheduler may hand out.
 */
export const registerNodeSchema = z
  .object({
    serverExternalId: z.string().min(1).max(200),
    name: z.string().min(2).max(63).regex(SLUG_PATTERN),
    labels: z.array(z.string().min(1).max(32).regex(/^[a-z0-9][a-z0-9-]*$/)).max(10).default(['wordpress']),
    maxSites: z.number().int().min(1).max(500).default(20),
    reservedMemoryMb: z.number().int().min(0).max(262_144).default(2_048),
    reservedDiskGb: z.number().int().min(0).max(100_000).default(40),
  })
  .strict();

export type RegisterNodeInput = z.infer<typeof registerNodeSchema>;
export type RegisterNodeRequest = z.input<typeof registerNodeSchema>;

export const nodeSchedulingCommandSchema = z.object({ state: z.enum(['active', 'cordoned']) }).strict();

/** Moving every site off a node: confirmed by typing the node's name. */
export const drainNodeSchema = z.object({ confirmation: z.string().min(1).max(63) }).strict();
